import React, { useEffect } from "react";
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
} from "@ey-xd/motif-react";
import "./DeleteSkuModal.scss";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store";
import { deleteSku } from "../../../../store/slices/CTDBSkuDeleteSlice";

interface DeleteSkuModalProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onDelete: (status: string) => void;
  selectedSku: string;
}

const DeleteSkuModal: React.FC<DeleteSkuModalProps> = ({
  show,
  setShow,
  onDelete,
  selectedSku,
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  const param = useParams();
  const productId = param.id;

  const dispatch = useDispatch<AppDispatch>();

  const handleDelete = async () => {
    try {
      const response = await dispatch(
        deleteSku({
          ProductId: productId,
          SkuId: selectedSku,
        })
      );
      if (response.payload.Status === "success") {
        onDelete("success");
        setShow(false);
      } else {
        onDelete("error");
        setShow(false);
        console.error(
          "Failed to delete SKU:",
          response.payload.Message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error deleting SKU:", error);
    }
  };

  return (
    <MotifModal
      id="DeleteSkuModal"
      show={show}
      onClose={() => {
        setShow(false);
      }}
      size="default"
      className="delete-sku-modal"
    >
      <MotifModalHeader className="delete-sku-header">
        {"Alert! Deleting SKU"}
      </MotifModalHeader>
      <MotifModalBody>
        <div>
          <p>
            You are about to delete the draft SKU.{" "}
            <span className="bold-text">This action cannot be undone.</span>
          </p>
          <p>
            Do you want to continue with the deletion or cancel the operation ?
          </p>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton variant={"secondary"} onClick={() => setShow(false)}>
          Cancel
        </MotifButton>
        <MotifButton variant={"primary"} onClick={() => handleDelete()}>
          Continue
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

export default DeleteSkuModal;
